import { api } from '../cloud/api';

// Detect "signed in" by attempting an authenticated read. 200 = yes, 401 = no.
// Any other failure (network, CORS) treated as not-signed-in to keep the
// signed-out flow accessible offline.
export async function isSignedIn(): Promise<boolean> {
    try {
        await api.devicesList();
        return true;
    } catch (ex) {
        const msg = ex instanceof Error ? ex.message : String(ex);
        if (msg === 'http_401') return false;
        // network / CORS — assume not signed in, but surface for debugging.
        // eslint-disable-next-line no-console
        console.warn('[session] devicesList probe failed:', msg);
        return false;
    }
}
